import React from 'react'
import * as R from 'remeda'

import {
  CustomerAttributeConditionalSelector,
  type CustomerAttributeConditionalSelectorProps,
} from '~/components/features/CustomerAttributeConditionalSelector'
import { type ConditionOperation } from '~/gql/graphql'

import { type CustomerAttribute } from '../utils'

export type CustomerAttributesInputProps = {
  conditionOperation: ConditionOperation
  customerAttributes: CustomerAttribute[]
  value: CustomerAttribute['id'][]
  onBlur: () => void
  onChange: (value: CustomerAttribute['id'][]) => void
}

export const CustomerAttributesInput = React.forwardRef<
  HTMLDivElement,
  CustomerAttributesInputProps
>(
  (
    { conditionOperation, customerAttributes, onBlur, onChange, value },
    ref,
  ) => {
    const handleChange = React.useCallback<
      EH<
        CustomerAttributeConditionalSelectorProps<CustomerAttribute>,
        'onChange'
      >
    >(
      (customerAttributeIds) => {
        onChange(
          R.intersection(
            customerAttributes.map(R.prop('id')),
            customerAttributeIds,
          ),
        )
      },
      [customerAttributes, onChange],
    )

    return (
      <CustomerAttributeConditionalSelector
        ref={ref}
        conditionOperation={conditionOperation}
        customerAttributes={customerAttributes}
        value={value}
        onBlur={onBlur}
        onChange={handleChange}
      />
    )
  },
)
